export enum CashierActionType {
  closeCashier = 'close-cashier',
  openCashier = 'open-cashier',
}

export enum Types {
  string = 'string',
}

export enum TabType {
  DELETED_ORDERS_REPORT = 'deleted_orders_report',
  ORDER_REPORT = 'order_report',
  DISH_REPORT = 'dish_report',
  ITEM_LEVEL_REPORT = 'item_level_report',
  INVENTORY_REPORT = 'inventory_report',
  PROMOTION_REPORT = 'promotion_report',
  SALES_REPORT = 'sales_report',
  EOD_REPORT = 'eod_report',
  PROFIT_LOSS_REPORT = 'profit_loss',
  CUSTOMER_REPORT = 'customer_report',
  CASH_BALENCE_REPORT = 'cash_balance',
}

export enum EodReportEnum {
  VIEW = 'view',
  PRINT = 'print',
  DOWNLOAD = 'download',
  PDF = 'pdf',
  DOWNLOAD_EOD = 'download_eod',
  EOD_REPORT = 'eod_report',
  END_OF_DAY_REPORT = 'END OF DAY REPORT',
  EOD_PRINTING_SETTINGS = 'eod_report_settings',
}

export enum DateRangeId {
  CUSTOM = 'custom',
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  LAST_WEEK = 'lastweek',
  THIS_MONTH = 'thismonth',
  LAST_MONTH = 'lastmonth',
  LAST_7_DAYS = 'last7days',
  LAST_30_DAYS = 'last30days',
  LAST_90_DAYS = 'last90days',
}

export enum ActionType {
  DOWNLOAD = 1,
  TABLE_DATA = 0,
}

export enum DishReportTabs {
  TOP_SELLING_DISH_TAB = 0,
  SALES_MARGIN_TAB = 1,
  TOP_ADDONS_TAB = 2,
  VOID_ITEMS_TAB = 3,
}

export enum PlType {
  SUMMARY = 'summary',
  EXPENSES = 'expenses',
}

export enum ExpenseType {
  ONETIME = 'onetime',
  RECURRING = 'recurring',
}

export enum SalesTabs {
  SALES_OVER_TIME = 0,
  SALES_BY_TRANSC = 1,
  SALES_BY_PMT = 2,
  SALES_OVER_PLT = 3,
}

export enum CashBalance {
  CASH_IN = 'cash-in',
  CASH_OUT = 'cash-out',
}

export enum ItemAnalyticsTab {
  TOP_SELLING_ITEMS = 1,
  SALES_MARGIN = 2,
  TOP_SELLING_ADD_ONS = 3,
  VOIDED_ITEMS = 4,
}

export enum DlRequestStatus {
  PENDING_DOWNLOAD = 1,
  ALREADY_DOWNLOADED = 2,
  REPORT_GENERATION_STARTED = 1,
  FAILED = 3,
}

export enum CustomerReportType {
  ORDER_RECORDS = 'customer_order_records',
  RATINGS_REVIEWS = 'customer_ratings_reviews',
}
